const { REACT_APP_NAME } = process.env;
import { Box, Card, CardContent, CardHeader, Grid, Typography } from "@mui/material"
import { FormWithdrawBalance } from "./FormWithdrawBalance"
import PageContainer from "src/components/container/PageContainer"

export const WithdrawFromBalance = () => {
    return (
        <>
            <PageContainer title={`${REACT_APP_NAME} | Вывести со счёта`} description="Вывести со счёта">
                <Box sx={{ my: 5 }}>
                    <Card>
                        <CardHeader title="Вывести" />
                        <CardContent>
                            <Typography mb={5} variant="h4" textAlign='center' sx={{ color: 'red' }}>
                                При Выводе: USDT(BЕР20) и ВТС - 1.5%<br />
                                Р2Р биржа: Продажа ВВ от 1$ - без %, т.е. (1$=100P)
                            </Typography>
                            <Grid container display='flex' justifyContent='center'>
                                <Grid item xs={12} md={8}>
                                    <FormWithdrawBalance />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Box>
            </ PageContainer >
        </>
    )
}
